<template>

  <div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <div v-if="nuevoActivo && idKit == null" class="text-left">
      <em class="kitActivo_svg"></em>
      <span v-if="nombreNuevoKit == null || nombreNuevoKit == ''" class="textSixe" style="color: #717171"> Nuevo Kit dental</span>
      <span v-else class="textSixe" style="color: #717171"> {{nombreNuevoKit}}</span>
    </div>

    <div>
      <div class="text-left"
          v-for="(kit, index) in arrayKitsProp"
           :key="index" >
        <div v-if="kit.registroActivoKit" style="cursor: pointer" @click="mostrarKit(kit)">
          <em class="kitActivo_svg"></em>
          <span class="textSixe" style="padding-left: 5px;"
          >{{ kit.nombreKit}}</span>
        </div>
        <div v-else style="cursor: pointer" @click="mostrarKit(kit)">
          <em class="kitInactivo_svg"></em>
          <span class="textSixe" style="padding-left: 5px; color: #B5B5B5"
          >{{ kit.nombreKit}}</span>
        </div>

      </div>
    </div>


  </div>

</template>

<script>
export default {
  name: "ListadoKits",
  props: {
    nombreNuevoKit: String,
    nuevoActivo: Boolean,
    arrayKitsProp: Array,
    idKit: Number,
  },
  data: () => ({
    version: process.env.VUE_APP_ENV_VERSION,
    debug: false,
  }),
  created() {
    this.debug = this.$localStorageService.getDebug();
  },
  methods: {
    mostrarKit(kit){
      this.$emit('mostrarKit', JSON.parse(JSON.stringify(kit)));
    }
  }
}
</script>

<style scoped>
.textSixe{
  font-size: .7em;
}
</style>